import moment from 'moment'

const isForeignBank = function() {
  return this.form.bank.isForeign == 1
}

const isInvoice = function() {
  //console.log(this.form.invoice, this.form.invoice == 1)

  return this.form.invoice == 1
}

const isExtra = function() {
  //console.log(this.form.invoice, this.form.invoice == 1)

  return this.form.extra == 1
}

var isEmailAgreement = function() {
  console.log("form:",this.form.emailAgreement, this.form.emailAgreement == 0)

  return this.form.emailAgreement == 0;
}

const isBankTransfer = function() {
  return this.form.bankTransfer == 1
}

const isCarriage = function() {
  return this.form.trainType == 'carriage'
}

const isTrain = function() {
  return this.form.trainType == 'train'
}

const minTrainCarriages = function() {
  //console.log(this.form.trainType,this.form.train.type);
  if(this.form.trainType != 'train') return true;
  if(this.form.train.type != 'Skład wagonowy') return true;
  let sum = 0;
  for(var i=0; i< this.form.train.carriages.length; i++)
    sum+=parseInt(this.form.train.carriages[i].count);
  //console.log("Ilosc wagonów:",sum);
  return sum >= 3;

}

const dateAfterDeparture = function(value){
  console.log("TAM:",this.form.connection.departureDate,"POWROT", value, "WYNIK: ",this.form.connection2.departureDate,moment(value).isSameOrAfter(this.form.connection.departureDate));
  if(!value) return true;
  return moment(value).isSameOrAfter(this.form.connection.departureDate)
}

export { isForeignBank, isInvoice, isBankTransfer, isCarriage, isTrain, isExtra, minTrainCarriages,dateAfterDeparture,isEmailAgreement }
